import PersonalizerApi from "@/services/personalizer_api";
import { RETRIEVE_PRESIGNED_URL } from "@/store/_actiontypes";
import { SET_PRESIGNED_URL } from "@/store/_mutationtypes";

const state = {
  presigned_url: "",
};

const actions = {
  [RETRIEVE_PRESIGNED_URL]({ commit }, { s3_key }) {
    return new Promise((resolve, reject) => {
      PersonalizerApi.post(`files/download`, {
        s3_key,
      }).then(
        (response) => {
          const presigned_url = response.data.detail?.download_url;
          commit(SET_PRESIGNED_URL, presigned_url);
          resolve(presigned_url);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },
};

const mutations = {
  [SET_PRESIGNED_URL](state, data) {
    state.presigned_url = data;
  },
};

export const download = {
  namespaced: true,
  state,
  actions,
  mutations,
};
